import React, { useCallback, useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs    from '@material-ui/core/Breadcrumbs';
import Button         from '@material-ui/core/Button';
import Link           from '@material-ui/core/Link';
import Table          from '@material-ui/core/Table';
import TableBody      from '@material-ui/core/TableBody';
import TableCell      from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow       from '@material-ui/core/TableRow';
import Typography     from '@material-ui/core/Typography';

import PeopleIcon from '@material-ui/icons/People';

import {
  create,
  date
} from '../util';
import NewPicture    from './NewPicture';
import NewText       from './NewText';
import Payments      from './Payments';
import UsableTickets from './UsableTickets';
import UsedTickets   from './UsedTickets';
import NewBirthdate  from './NewBirthdate';

const style = {
  attender: makeStyles((theme) => ({
    attenders: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
    },
    link: {
      display: 'flex',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(8),
      paddingLeft: theme.spacing(16),
      paddingRight: theme.spacing(16),
      paddingTop: theme.spacing(8),
    },
  })),
};

function Information(props) {
  const [newBirthdate, setNewBirthdate ] = useState(create.birthdate());
  const [newEmail    , setNewEmail     ] = useState(create.email());
  const [newName     , setNewName      ] = useState(create.name());
  const [newNote     , setNewNote      ] = useState(create.note());
  const [newPicture  , setNewPicture   ] = useState(create.phone());
  const [newPhone    , setNewPhone     ] = useState(create.picture());

  const { request } = props.context.getStates();

  function updateAttender(body, callback) {
    request.postSecurely('/attender/update', {
      birthdate: props.attender.birthdate,
      email    : props.attender.email,
      name     : props.attender.name,
      note     : props.attender.note,
      phone    : props.attender.phone,
      ...body,
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else if ('attender' in response) {
        props.setAttender(response.attender);
        callback();
      }
    });
  }

  return(
    <div>
      <NewPicture newPicture={newPicture}
        context={props.context}
        setNewPicture={setNewPicture}
        setAttender={props.setAttender}
      />

      <NewText title='이름' rowid={newName.rowid} value={newName.name}
        onCancel={(event) => { setNewName(create.name()); }}
        onChange={(event) => { setNewName({...newName, name: event.target.value}); }}
        onSubmit={(event) => { updateAttender(newName, () => { setNewName(create.name()); }); }}
      />

      <NewBirthdate newBirthdate={newBirthdate}
        setNewBirthdate={setNewBirthdate}
        updateAttender={updateAttender}
      />

      <NewText title='이메일' rowid={newEmail.rowid} value={newEmail.email}
        onCancel={(event) => { setNewEmail(create.email()); }}
        onChange={(event) => { setNewEmail({...newEmail, email: event.target.value}); }}
        onSubmit={(event) => { updateAttender(newEmail, () => { setNewEmail(create.email()); }); }}
      />

      <NewText title='전화번호' rowid={newPhone.rowid} value={newPhone.phone}
        onCancel={(event) => { setNewPhone(create.phone()); }}
        onChange={(event) => { setNewPhone({...newPhone, phone: event.target.value}); }}
        onSubmit={(event) => { updateAttender(newPhone, () => { setNewPhone(create.phone()); }); }}
      />

      <NewText title='비고' rowid={newNote.rowid} value={newNote.note}
        multiline={true} rows={4}
        onCancel={(event) => { setNewNote(create.note()); }}
        onChange={(event) => { setNewNote({...newNote, note: event.target.value}); }}
        onSubmit={(event) => { updateAttender(newNote, () => { setNewNote(create.note()); }); }}
      />

      <Typography variant="h6">{'회원 정보'}</Typography>

      <TableContainer>
        <Table>
          <TableBody>
            <TableRow hover>
              <TableCell variant="head">{'사진'}</TableCell>
              <TableCell>
                {props.attender.picture256 === '' ? (null) : (
                  <img alt={''} src={'data:image/jpeg;base64,' + props.attender.picture256} />
                )}
              </TableCell>
              <TableCell align="right">
                <Button onClick={(event) => {
                  setNewPicture(create.picture(props.attender.rowid));
                }}>{'수정'}</Button>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell variant="head">{'이름'}</TableCell>
              <TableCell>{props.attender.name}</TableCell>
              <TableCell align="right">
                <Button onClick={(event) => {
                  setNewName(create.name(props.attender.rowid, props.attender.name));
                }}>{'수정'}</Button>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell variant="head">{'생년월일'}</TableCell>
              <TableCell>
                {date.withoutTime(props.attender.birthdate)}
              </TableCell>
              <TableCell align="right">
                <Button onClick={(event) => {
                  setNewBirthdate(create.birthdate(props.attender.rowid, props.attender.birthdate));
                }}>{'수정'}</Button>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell variant="head">{'이메일'}</TableCell>
              <TableCell>{props.attender.email}</TableCell>
              <TableCell align="right">
                <Button onClick={(event) => {
                  setNewEmail(create.email(props.attender.rowid, props.attender.email));
                }}>{'수정'}</Button>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell variant="head">{'전화번호'}</TableCell>
              <TableCell>{props.attender.phone}</TableCell>
              <TableCell align="right">
                <Button onClick={(event) => {
                  setNewPhone(create.phone(props.attender.rowid, props.attender.phone));
                }}>{'수정'}</Button>
              </TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell variant="head">{'비고'}</TableCell>
              <TableCell>
                {props.attender.note.split('\n').map((line, index) => (
                  <span key={index}>{line}<br/></span>
                ))}
              </TableCell>
              <TableCell align="right">
                <Button onClick={(event) => {
                  setNewNote(create.note(props.attender.rowid, props.attender.note));
                }}>{'수정'}</Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default function Attender(props) {
  const classes = style.attender();

  const [ attender, setAttender ] = useState(create.attender());
  const [ revision, setRevision ] = useState(0);

  const {
    path,
    request,
    setPath,
    ticketer
  } = props.context.getStates();

  const fetchAttender = useCallback(() => {
    if (attender?.rowid > -1) {
      request.postSecurely('/attender/select', {
        attender: attender.rowid,
        ticketer,
      }, (response) => {
        if ('error' in response) {
          console.error(response);
        } else if ('attender' in response) {
          setAttender(response.attender);
          setRevision(0);
        }
      });
    }
  }, [
    attender.rowid,
    request,
    ticketer,
  ])

  useEffect(() => {
    fetchAttender();
  }, [
    fetchAttender,
  ]);

  useEffect(() => {
    setAttender(create.attender(parseInt(
      path.substring(path.indexOf('?id=') + 4)
    )));
  }, [path]);

  if (attender?.rowid > -1) {
    return (
      <div className={classes.root}>
        <Breadcrumbs>
          <Link href="#"
            className={classes.attenders}
            color="inherit"
            onClick={(event) => {
              event.preventDefault();
              if (path.startsWith('/attenders/attender')) {
                setPath('/attenders');
              } else if (path.startsWith('/schedules/attender')) {
                setPath('/schedules');
              }
            }}
          >
            <PeopleIcon />
            {(() => {
              if (path.startsWith('/attenders/attender')) {
                return '회원';
              } else if (path.startsWith('/schedules/attender')) {
                return '일정';
              }
            })()}
          </Link>

          <Typography color="textPrimary">
            {attender.name}
          </Typography>
        </Breadcrumbs>

        <Information context={props.context}
          attender={attender}
          setAttender={setAttender}
        />

        <Payments attender={attender}
          context={props.context}
          revision={revision}
          setRevision={setRevision}
        />

        <UsableTickets attender={attender}
          context={props.context}
          revision={revision}
          setRevision={setRevision}
        />

        <UsedTickets attender={attender}
          context={props.context}
          revision={revision}
          setRevision={setRevision}
        />
      </div>
    )
  } else {
    return null;
  }
}